import React, { useState, useEffect } from 'react';
import './ProfileMobile.css';
import PersonalDetailsMobile from "./PersonalDetailsMobile"
import SubscriptionDetailsMobile from "./SubscriptionDetailsMobile"

function ProfileMobile(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma - User Profile";
    const [optionSelected, setOptionSelected] = useState("one");
    useEffect(() => {

    }, [])

    return (
        <div className="faq commonContainer" style={{ padding: "10px 5px", fontSize:"9px" }} >
            <div className="container">
                <div className="ProfileContainer">
                    <div className="leftOptionProfile">
                        <div className="ProfileNav" onClick={() => setOptionSelected("one")} style={optionSelected === "one" ? { backgroundColor: "black", color: "white" } : {}}>
                            Personal Details
                        </div>

                        <div className="ProfileNav" onClick={() => setOptionSelected("five")} style={optionSelected === "five" ? { backgroundColor: "black", color: "white" } : {}}>
                            Subscription Details
                        </div>
                    </div>
                    <div className="RightDetailsProfile" style={{ paddingRight: "10px" }}>
                        {optionSelected === "one" &&
                            <PersonalDetailsMobile />
                        }
                        {optionSelected === "five" &&
                            <SubscriptionDetailsMobile />
                        }
                    </div>
                </div>

            </div>
        </div>
    );
}
export default ProfileMobile;